import { gql } from 'graphql-tag';
import { INACTIVE_COFFEE_CUSTOMER_FIELDS, PAGINATION } from './Fragments';

export const GET_INACTIVE_COFFEE_CUSTOMERS_REPORT = gql`
    query GetInactiveCoffeeCustomersReport(
        $page: Int
        $limit: Int
        $months: Int!
        $rental_agreement_only: Boolean
        $col: String
        $type: String
    ) {
        inactive_coffee_customers_report(
            limit: $limit
            page: $page
            months: $months
            rental_agreement_only: $rental_agreement_only
            col: $col
            type: $type
        ) {
            ...Pagination
            data {
                ...InactiveCoffeeCustomerFields
            }
        }
    }
    ${INACTIVE_COFFEE_CUSTOMER_FIELDS}
    ${PAGINATION}
`;

export const SEARCH_INACTIVE_COFFEE_CUSTOMERS = gql`
    query SearchInactiveCoffeeCustomers(
        $page: Int
        $limit: Int
        $filter: String
        $search_key: String
        $months: Int!
        $rental_agreement_only: Boolean
        $locale: String
        $types: String
        $col: String
        $type: String
    ) {
        search_inactive_coffee_customers(
            limit: $limit
            page: $page
            filter: $filter
            search_key: $search_key
            months: $months
            rental_agreement_only: $rental_agreement_only
            locale: $locale
            types: $types
            col: $col
            type: $type
        ) {
            ...Pagination
            data {
                ...InactiveCoffeeCustomerFields
            }
        }
    }
    ${INACTIVE_COFFEE_CUSTOMER_FIELDS}
    ${PAGINATION}
`;

export default { GET_INACTIVE_COFFEE_CUSTOMERS_REPORT, SEARCH_INACTIVE_COFFEE_CUSTOMERS };
